import { h as __h } from "preact";
import { Component } from "preact";
import { ssoProviderRefResponse } from "~/backend/validate.js";
import { apiHost, query, response } from "~/lib/api.js";
import html from "~/util/html.js";
import { search } from "~/util/router.js";
import { array } from "~/util/validate.js";
import Button from "~/component/Button.js";
import PublicLayout, { FooterPrompt } from "./PublicLayout.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./SsoChoose.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./SsoChoose.module.css", import.meta.url);
const css = adopt(sheet);
const expired = "SSO session expired. Please try again.";

/** Lets a person pick which of their enterprise's identity providers to log in with. */
export default class SsoChoose extends Component {
  #nonce = search.value.nonce ?? "";
  #providers = query(() => ({
    key: ["/v2/auth/sso/providers", {
      nonce: this.#nonce
    }],
    enabled: !!this.#nonce
  }), {
    schema: response(array(ssoProviderRefResponse)),
    noAuth: true
  });

  /** @param {string} providerId */
  #choose(providerId) {
    const params = new URLSearchParams({
      nonce: this.#nonce,
      provider_id: providerId
    });
    window.location.href = `${apiHost.value}/v2/auth/sso/login/provider?${params}`;
  }
  render() {
    const providers = this.#providers.data?.data;
    let error = "";
    // the API rejects an unknown or expired nonce
    if (!this.#nonce || this.#providers.error) error = expired;else if (providers && !providers.length) error = "SSO is not configured for this email domain.";
    return __h(PublicLayout, {
      title: "Sign in with your company"
    }, __h("div", {
      "class": css.form
    }, error ? __h("p", {
      "class": css.error
    }, error) : providers ? [__h("p", {}, "Choose your identity provider."), providers.map(provider => __h(Button, {
      key: provider.id,
      level: "secondary",
      onClick: () => this.#choose(provider.id)
    }, "Continue with ", provider.name))] : __h("p", {}, "Loading..."), __h(FooterPrompt, {}, __h("a", {
      href: "/login/sso/",
      "data-animate": true
    }, "Back to login"))));
  }
}